function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-113.8,343.3l-30.7-14.8l21.8,24l-20,10.4l20.4,3.3l-4.1,25.1l18.9-19.2l17.8,17.8l-3.7-24l20-3.3l-17.8-10.7l12.6-17.8 l-21.1,5.5l-8.1-22.6L-113.8,343.3z M-117.9,373.7l2.2-12.6l-10.4-1.5l11.5-6.3l-8.9-9.6l13,6.3l3.3-13.7l3.7,10l11.1-3l-7.1,10 l10,5.9l-10.7,1.9l1.9,12.2l-9.6-9.2L-117.9,373.7z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-113.8,428.9l-30.7-14.8l21.8,24l-20,10.4l20.4,3.3l-4.1,25.1l18.9-19.2l17.8,17.8l-3.7-24l20-3.3l-17.8-10.7l12.6-17.8 l-21.1,5.5l-8.1-22.6L-113.8,428.9z M-117.9,459.2l2.2-12.6l-10.4-1.5l11.5-6.3l-8.9-9.6l13,6.3l3.3-13.7l3.7,10l11.1-3l-7.1,10 l10,5.9l-10.7,1.9l1.9,12.2l-9.6-9.2L-117.9,459.2z"
});

var SvgSwrpgSuccessSuccess = function SvgSwrpgSuccessSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgSuccessSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-success-success.4e7075b1.svg";
export { ForwardRef as ReactComponent };